import React from 'react'

const AddTacheIdRapport = () => {
  return (
    <div>AddTacheIdRapport</div>
  )
}

export default AddTacheIdRapport